import type {PermissionType} from '@hconnect/apiclient'

import type {PermissionParsed} from '../types'

import {checkMultiplePermissions} from './checkMultiplePermissions'
import {checkPermissionAccessByDataScope} from './checkPermissionAccessByDataScope'

interface PlantContext {
  plantId: string
  countryId: string
}

/*
 * Core permission checking logic that works with permissions data directly
 */
export const checkPermissionsByDataScope = (
  permissions: PermissionParsed[],
  plantContext: PlantContext,
  types: PermissionType[]
): boolean => {
  return checkMultiplePermissions({
    requiredPermissionTypes: types,
    permissions,
    testFn: (permission) =>
      checkPermissionAccessByDataScope(
        plantContext.countryId,
        plantContext.plantId,
        permission.parsedDataScope
      )
  })
}
